module.exports = __webpack_public_path__ + "img/listImg1.bd63c886.svg";